/*!
 * WORKIT — variant picker out-of-stock greying
 *
 * Rule (applies across the whole store):
 *   - LAST option row: a value is greyed when no variant with that value is
 *     available under the current upstream selection.
 *   - NON-LAST option rows (Colour, Gender, Coverage, etc.): a value is greyed
 *     ONLY when every variant with that value is out of stock. Upstream rows
 *     do not depend on downstream clicks, so shoppers can freely click between
 *     them and the last row re-evaluates against the new selection.
 *
 * Applies to both radio pickers (.radio__button) and swatch pickers
 * (<radio-swatch> / .swatch__button). The theme's native .sold-out class on
 * the <input> paints the diagonal line on swatches and greys radio labels;
 * we layer our own .radio__button--soldout on the parent span so radios also
 * get an opacity/line-through treatment via custom-fixes.css.
 *
 * Preview gate: append ?wk_preview=1 to any product URL while testing.
 * Flip ALWAYS_ON to true once approved to remove the gate.
 */
(function () {
  var ALWAYS_ON = true; // approved by Max 2026-04-19 — runs for all shoppers

  if (!ALWAYS_ON) {
    try {
      var qp = new URLSearchParams(window.location.search);
      if (qp.get('wk_preview') !== '1') return;
    } catch (e) { return; }
  }

  function init() {
    var jsonNodes = document.querySelectorAll('script[data-product-json]');
    jsonNodes.forEach(function (jsonEl) {
      var product;
      try { product = JSON.parse(jsonEl.textContent); }
      catch (e) { return; }
      if (!product || !Array.isArray(product.variants) || !Array.isArray(product.options)) return;

      // Find the closest product-form scope so we don't bleed across products
      // (quickviews / related-product sections render multiple pickers).
      var scope = jsonEl.closest('product-form, [data-product-form], .product__wrapper, .product, form[action*="/cart/add"]');
      if (!scope) scope = jsonEl.parentElement;
      if (!scope) return;

      bindPicker(scope, product);
    });
  }

  function bindPicker(scope, product) {
    if (scope.dataset.workitGreyingBound === '1') return;
    scope.dataset.workitGreyingBound = '1';

    var optionCount = product.options.length;        // 1–3
    var lastPos = optionCount;                       // 1-indexed
    var radios = scope.querySelectorAll('input[data-single-option-selector]');
    if (!radios.length) return;

    var keys = ['', 'option1', 'option2', 'option3'];

    function getSelected() {
      var sel = {};
      radios.forEach(function (inp) {
        if (!inp.checked) return;
        var pos = parseInt((inp.dataset.index || '').replace('option', ''), 10);
        if (pos) sel[pos] = inp.value;
      });
      return sel;
    }

    function isAvailable(pos, val, sel) {
      var field = keys[pos];
      if (pos === lastPos) {
        // LAST option: must satisfy current selection on every other option.
        return product.variants.some(function (v) {
          if (v[field] !== val) return false;
          for (var i = 1; i <= optionCount; i++) {
            if (i === pos) continue;
            if (sel[i] != null && v[keys[i]] !== sel[i]) return false;
          }
          return v.available;
        });
      }
      // NON-LAST option: grey only if EVERY variant with that value is OOS.
      // Independent of current selection so upstream rows never flip based on
      // what the shopper clicked downstream.
      return product.variants.some(function (v) {
        return v[field] === val && v.available;
      });
    }

    function update() {
      var sel = getSelected();
      radios.forEach(function (inp) {
        var pos = parseInt((inp.dataset.index || '').replace('option', ''), 10);
        if (!pos) return;
        // Match radios and swatches. radio-swatch is the custom element the
        // theme uses for colour/material swatches; .swatch__button is the
        // class it carries. Fall back to .radio__button for vanilla radios.
        var btn = inp.closest('radio-swatch, .swatch__button, .radio__button');
        if (!btn) return;

        var isSwatch = btn.matches('radio-swatch, .swatch__button');
        var avail = isAvailable(pos, inp.value, sel);

        if (avail) {
          // Theme Liquid can render class="sold-out"/"unavailable" directly on
          // the <input> based on its own (looser) rule. Strip those so our
          // rule wins and nothing looks pre-blocked that shouldn't be.
          inp.classList.remove('sold-out');
          inp.classList.remove('unavailable');
          if (inp.disabled) inp.disabled = false;
          btn.classList.remove('radio__button--soldout');
        } else {
          if (isSwatch) {
            // Swatches use the theme's native CSS that draws a diagonal line
            // via `input.sold-out ~ label::before`. Keep our custom class off
            // so we don't double up.
            inp.classList.add('sold-out');
          } else {
            // Radios use our custom class on the parent span for the grey
            // opacity + line-through treatment from custom-fixes.css.
            btn.classList.add('radio__button--soldout');
          }
        }
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
